import React from "react";

import styles from "./SearchInput.module.scss";

const SearchInput = React.forwardRef(
  ({ hasCriteria, id, onChange, searchText, ...rest }, ref) => (
    <input
      autoComplete="off"
      className={styles.base}
      id={id}
      onChange={({ target: { value } }) => onChange(value)}
      onBlur={rest.onBlur}
      onFocus={rest.onFocus}
      onKeyDown={rest.onKeyDown}
      placeholder={`${
        !hasCriteria ? "Begin" : "Continue"
      } typing search criteria`}
      ref={ref}
      type="text"
      value={searchText}
    />
  )
);

export default SearchInput;
